import React from 'react'
import './PaymentBackButton.css'
import { TbChevronLeft } from 'react-icons/tb'

export default function PaymentBackButton({ setCurrentPage }) {
    return (
        <div onClick={()=>setCurrentPage("selectPlan")} className='payment-back-button'><TbChevronLeft /></div>
    )
}
